"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const zod_1 = require("zod");
var APIError;
(function (APIError_1) {
    let BadRequestCode;
    (function (BadRequestCode) {
        BadRequestCode[BadRequestCode["RequestDataInvalid"] = 1000] = "RequestDataInvalid";
    })(BadRequestCode = APIError_1.BadRequestCode || (APIError_1.BadRequestCode = {}));
    let UnauthorizedCode;
    (function (UnauthorizedCode) {
        UnauthorizedCode[UnauthorizedCode["AccessTokenInvalid"] = 2000] = "AccessTokenInvalid";
        UnauthorizedCode[UnauthorizedCode["AccessTokenExpired"] = 2001] = "AccessTokenExpired";
        UnauthorizedCode[UnauthorizedCode["NotSignedIn"] = 2002] = "NotSignedIn";
        UnauthorizedCode[UnauthorizedCode["RefreshTokenInvalid"] = 2003] = "RefreshTokenInvalid";
        UnauthorizedCode[UnauthorizedCode["SessionInvalid"] = 2004] = "SessionInvalid";
    })(UnauthorizedCode = APIError_1.UnauthorizedCode || (APIError_1.UnauthorizedCode = {}));
    let ForbiddenCode;
    (function (ForbiddenCode) {
        ForbiddenCode[ForbiddenCode["NotAllowed"] = 3000] = "NotAllowed";
        ForbiddenCode[ForbiddenCode["UserBanned"] = 3001] = "UserBanned";
        ForbiddenCode[ForbiddenCode["UserIsBlocked"] = 3002] = "UserIsBlocked";
    })(ForbiddenCode = APIError_1.ForbiddenCode || (APIError_1.ForbiddenCode = {}));
    let NotFoundCode;
    (function (NotFoundCode) {
        NotFoundCode[NotFoundCode["EndpointNotFound"] = 4000] = "EndpointNotFound";
        NotFoundCode[NotFoundCode["ResourceNotFound"] = 4001] = "ResourceNotFound";
        NotFoundCode[NotFoundCode["UserNotFound"] = 4002] = "UserNotFound";
    })(NotFoundCode = APIError_1.NotFoundCode || (APIError_1.NotFoundCode = {}));
    let UnprocessableEntityCode;
    (function (UnprocessableEntityCode) {
        UnprocessableEntityCode[UnprocessableEntityCode["AccessVerificationCodeExpired"] = 5000] = "AccessVerificationCodeExpired";
        UnprocessableEntityCode[UnprocessableEntityCode["AccessVerificationCodeInvalid"] = 5001] = "AccessVerificationCodeInvalid";
        UnprocessableEntityCode[UnprocessableEntityCode["AccessVerificationAttemptsExceeded"] = 5002] = "AccessVerificationAttemptsExceeded";
        UnprocessableEntityCode[UnprocessableEntityCode["AccessVerificationAlreadyCompleted"] = 5003] = "AccessVerificationAlreadyCompleted";
        UnprocessableEntityCode[UnprocessableEntityCode["AccessNotVerified"] = 5004] = "AccessNotVerified";
        UnprocessableEntityCode[UnprocessableEntityCode["FileTooLarge"] = 5005] = "FileTooLarge";
        UnprocessableEntityCode[UnprocessableEntityCode["FileInvalid"] = 5006] = "FileInvalid";
        UnprocessableEntityCode[UnprocessableEntityCode["EmailTaken"] = 5007] = "EmailTaken";
        UnprocessableEntityCode[UnprocessableEntityCode["PhoneNumberTaken"] = 5008] = "PhoneNumberTaken";
        UnprocessableEntityCode[UnprocessableEntityCode["GoogleAuthenticationNotSupported"] = 5009] = "GoogleAuthenticationNotSupported";
        UnprocessableEntityCode[UnprocessableEntityCode["GoogleIdentityTokenInvalid"] = 5010] = "GoogleIdentityTokenInvalid";
        UnprocessableEntityCode[UnprocessableEntityCode["GoogleIdentityExistsAlready"] = 5011] = "GoogleIdentityExistsAlready";
    })(UnprocessableEntityCode = APIError_1.UnprocessableEntityCode || (APIError_1.UnprocessableEntityCode = {}));
    let TooManyRequestsCode;
    (function (TooManyRequestsCode) {
        TooManyRequestsCode[TooManyRequestsCode["AccessVerificationBeginRateLimit"] = 6000] = "AccessVerificationBeginRateLimit";
    })(TooManyRequestsCode = APIError_1.TooManyRequestsCode || (APIError_1.TooManyRequestsCode = {}));
    let InternalServerErrorCode;
    (function (InternalServerErrorCode) {
        InternalServerErrorCode[InternalServerErrorCode["ServerError"] = 7000] = "ServerError";
    })(InternalServerErrorCode = APIError_1.InternalServerErrorCode || (APIError_1.InternalServerErrorCode = {}));
    APIError_1.ErrorCode = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, BadRequestCode), UnauthorizedCode), ForbiddenCode), NotFoundCode), UnprocessableEntityCode), TooManyRequestsCode), InternalServerErrorCode);
    APIError_1.ErrorStatus = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Object.fromEntries(Object.entries(BadRequestCode).map(([key, _]) => [key, 400]))), Object.fromEntries(Object.entries(UnauthorizedCode).map(([key, _]) => [key, 401]))), Object.fromEntries(Object.entries(ForbiddenCode).map(([key, _]) => [key, 403]))), Object.fromEntries(Object.entries(NotFoundCode).map(([key, _]) => [key, 404]))), Object.fromEntries(Object.entries(UnprocessableEntityCode).map(([key, _]) => [key, 422]))), Object.fromEntries(Object.entries(TooManyRequestsCode).map(([key, _]) => [key, 429]))), Object.fromEntries(Object.entries(InternalServerErrorCode).map(([key, _]) => [key, 500])));
    APIError_1.responseSchema = zod_1.z.object({
        code: zod_1.z.number(),
        fields: zod_1.z.string().array().optional(),
        message: zod_1.z.string(),
        statusCode: zod_1.z.number(),
        timeout: zod_1.z.number().optional(),
    });
    /**
     * The APIError can be used to return any error in a fixed format.
     * @param statusCode - A HTTP status code that describes the error.
     * @param message - A message that specifies the error.
     * @param options - Further parameters that can be set.
     */
    class APIError extends Error {
        constructor(statusCode, message, { code, fields, timeout }) {
            super();
            this.name = "APIError";
            this.message = message;
            this.statusCode = statusCode;
            this.code = code;
            this.fields = fields;
            this.timeout = timeout;
        }
        /**
         * Alias to response for socket.io
         */
        get data() {
            return this.response;
        }
        /**
         * Builds a response object that can be returned to the client..
         * @returns The response object.
         */
        get response() {
            let data = { code: this.code, message: this.message, statusCode: this.statusCode };
            if (this.fields !== undefined)
                data = Object.assign(Object.assign({}, data), { fields: this.fields });
            if (this.timeout !== undefined)
                data = Object.assign(Object.assign({}, data), { timeout: this.timeout });
            return data;
        }
        /**
         * Creates a response for express framework controllers.
         * @param res - The express response.
         * @returns The modified express response object.
         */
        expressResponse(res) {
            return res.status(this.statusCode).json(this.response);
        }
    }
    APIError_1.APIError = APIError;
})(APIError || (APIError = {}));
exports.default = APIError;
